<div class="app-layout">
  <menu></menu>

  <!-- START PAGE-CONTAINER -->
  <div class="page-container">

    <div
         *ngIf="currentUser && sysPref.presentation.showEnvironmentBanner"
         [style.background-color]="sysPref.presentation.bannerColor"
         [style.color]="sysPref.presentation.bannerColor | functionPure: calculateBannerTextColorFunc"
         class="env-banner-container">
      <div class="env-banner"><span>{{sysPref.presentation.environmentName}}</span></div>
    </div>
    <div class="user-info">
      <notification></notification>
      <div ngbDropdown
          [autoClose]="true"
          placement="bottom-right"
          class="d-inline-block"
          autoClose="outside"
          *ngIf="currentUser"
          class="user-info-container">
        <div id="currentUserDropdownToggle" class="user-name" ngbDropdownToggle>
          <img src="/assets/images/icons/top-bar/user.svg" />
          <span>{{ currentUser?.fullName }}<span *ngIf="currentUser?.impersonatingUserId">&nbsp;&nbsp;(<span
                    class="impersonation-title">{{ 'Common.SearchColumnsAndDetailsFields.Impersonating' | translate }}</span>)</span></span>
          <div class="arrow">
            <img src="/assets/images/icons/top-bar/ico-chevron-down.svg" />
          </div>
        </div>
        <div ngbDropdownMenu aria-labelledby="currentUserDropdownToggle" class="current-user-dropdown">
          <div class="dropdown-item" routerLink="/user-settings" [queryParams]="{id: currentUser?.id}">
            <img src="/assets/images/icons/top-bar/settings.svg" width="16px" height="16px" />
            <span class="text">{{ 'Common.SearchColumnsAndDetailsFields.Settings' | translate }}</span>
          </div>
          <div class="dropdown-item" (click)="downloadHoah()">
            <img src="/assets/images/icons/top-bar/settings.svg" width="16px" height="16px" />
            <span class="text">Download Noah Installer</span>
          </div>
          <div class="dropdown-item" (click)="openTrainingVideo()"
              *ngIf="currentUser?.systemPreferences?.trainingMaterialUrl">
            <img src="/assets/images/icons/top-bar/play.svg" width="16px" height="16px" />
            <span class="text">{{ 'Common.SearchColumnsAndDetailsFields.TrainingVideos' | translate }}</span>
          </div>
          <div class="dropdown-item" (click)="stopImpersonation()" *ngIf="currentUser?.impersonatingUserId">
            <img src="/assets/images/icons/top-bar/logout.svg" alt="Stop" width="16px" height="13px" />
            <span class="text">{{ 'Common.SearchActionsAndDetailsActions.StopImpersonation' | translate }}</span>
          </div>
          <div class="dropdown-item" (click)="logout()">
            <img src="/assets/images/icons/top-bar/logout.svg" alt="Log Off" width="16px" height="13px" />
            <span class="text">{{ 'Common.SearchColumnsAndDetailsFields.Signout' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <a href="#" class="btn-link toggle-sidebar d-lg-none d-xl-none pg pg-menu" data-toggle="sidebar"></a> -->

    <!-- START PAGE CONTENT WRAPPER -->
    <div class="page-content-wrapper">
      <div class="content">
        <!--<div class="container-fluid container-fixed-lg">
        <breadcrumb></breadcrumb>
      </div>-->
        <div class="content-container">
          <loader [show]="isLoading"></loader>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
